import React, { useState, useRef, useEffect } from 'react';
import * as THREE from 'three';
// eslint-disable-next-line no-restricted-imports -- CSS paylaşımlı, components/TypeMenus/'ta kaldı
import '../../../components/TypeMenus/MachineTypeMenu.css';
import { createMachineSymbol } from '../../../factory/symbols/createMachines';
import { useDragHandler } from '../../../utils/useDragHandler';

const machines = [
  { name: 'Çamaşır Makinası', power: [2500] },
  { name: 'Kurutma Makinesi', power: [2500] },
  { name: 'Bulaşık Makinesi', power: [2500] },
  { name: 'Fırın', power: [2000] },
  { name: 'Motor', power: [550, 750, 1100, 1500, 2200, 3000, 4000, 5500, 7500] },
  { name: 'Kombi', power: [300] },
  { name: 'Klima', power: [1500, 2000, 2500] },
  { name: 'Fan', power: [550, 750, 1100, 1500, 2200, 3000, 4000, 5500, 7500, 11000, 15000, 18500] },
  { name: 'Hidrofor', power: [550, 750, 1100, 1500, 2200, 3000, 4000, 5500] },
  { name: 'Yangın Pompası', power: [1100, 1500, 2200, 3000, 4000, 5500, 7500, 11000, 15000, 18500] }
];

export default function MachineTypeMenu({
  x,
  y,
  onClose,
  machineDetails,
  onDrag,
  scene,
}) {
  const [machine, setMachine] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState({ name: 'Çamaşır Makinası', power: [2500] });
  const [power, setPower] = useState(2500);

  const menuRef = useRef(null);

  useEffect(() => {
    // Seçilen machine’i sahneden bul
    scene.traverse(obj => {
      if (obj.userData.id === machineDetails.ID) {
        setMachine(obj);
        const { machineType, power } = obj.userData;
        const foundMachine = machines.find(m => m.name === machineType);
        if (foundMachine) {
          setSelectedMachine(foundMachine);
          setPower(power);
        }
      }
    });
  }, [machineDetails, scene]);

 
  const updateMachineSymbol = (machineType, machinePower) => {
    if (!machine) return;
    const oldColor = getMachineColor(machine); // örnek fonksiyon
 
    const {
      id,
      basePoint,
      isPreview,
      isSelectable,
      type,
      rotate,
      angle,
      dir
    } = machine.userData;

    // Ensure dir is Vector3
    const direction = (dir && dir.x !== undefined) 
        ? new THREE.Vector3(dir.x, dir.y, dir.z || 0) 
        : new THREE.Vector3(1, 0, 0);

    // Eskiyi temizle (fpMesh altına reparent edilmiş olabilir, scene.remove çalışmaz)
    const oldParent = machine.parent;
    machine.removeFromParent();
    machine.traverse(child => {
      if (child.geometry) child.geometry.dispose();
      if (child.material) child.material.dispose();
    });
  
    const newMachine = createMachineSymbol(
      scene,
      new THREE.Vector3(basePoint.x, basePoint.y, 0),
      direction,
      oldColor,
      isPreview ?? true,
      machineType,
      machinePower,
      angle
    );
    
    // Yeni makineyi scene'e ekle (sweep fpMesh altına reparent edecek)
    if (newMachine) {
      scene.add(newMachine);
      newMachine.userData = {
        id,
        basePoint,
        isPreview,
        isSelectable,
        type,
        rotate,
        machineType,
        power: machinePower,
        angle,
        dir: direction
      };
      setMachine(newMachine);
    } else {
      console.warn("❌ createMachineSymbol hiçbir şey döndürmedi!");
    }
    
  
    setMachine(newMachine);
  };
   
  const handlePowerSelect = (e) => {
    const newPower = Number(e.target.value);
    setPower(newPower);
    updateMachineSymbol(selectedMachine.name, newPower);
  };
  function getMachineColor(obj) {
    let color = null;
    // Line/LineLoop'lardan renk al (kare border, daireler vb.)
    obj.traverse(child => {
      if (color !== null) return;
      if ((child.isLine || child.isLineLoop) && child.material?.color) {
        color = child.material.color.getHex();
      }
    });
    // Fallback: Mesh children (gizmo'lar hariç)
    if (color === null) {
      obj.traverse(child => {
        if (color !== null) return;
        if (child.isMesh && child.material?.color &&
            child.userData?.type !== 'rotateGizmo') {
          color = child.material.color.getHex();
        }
      });
    }
    return color ?? 0x00ffff;
  }
  

  const { handleMouseDown } = useDragHandler(onDrag);

  const handleMouseDownWithStop = (e) => {
    e.stopPropagation();
    handleMouseDown(e);
  };


  return (
    <div
      ref={menuRef}
      className="machine-type-menu"
      style={{ left: x, top: y }}
    >
      <div onMouseDown={handleMouseDownWithStop} className="machine-type-menu-header">
        {selectedMachine.name}/{power} W
        <button
          className="close-button"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ×
        </button>
      </div>
      <div className="machine-type-options">
        <div className="machine-type-details-box">
          <table className="machine-type-details-table">
            <tbody>
              <tr>
                <td className="label-cell">Cihaz</td>
                <td>
                  <select
                    style={{ width: "100%", maxWidth: "160px" }}
                    value={selectedMachine.name}
                    onChange={(e) => {
                      const machine = machines.find(m => m.name === e.target.value);
                      if (machine) {
                        setSelectedMachine(machine);
                        setPower(machine.power[0]);
                        updateMachineSymbol(machine.name, machine.power[0]); // 🔥 ekledik
                      }
                    }}
                    
                  >
                    {machines.map((mach) => (
                      <option key={mach.name} value={mach.name}>{mach.name}</option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr>
                <td className="label-cell">Güç</td>
                <td>
                  <select
                    style={{ width: "100%", maxWidth: "160px" }}
                    value={power}
                    onChange={(e) => {
                      const newPower = Number(e.target.value);
                      setPower(newPower);
                      updateMachineSymbol(selectedMachine.name, newPower); // 🔥 burası da önemli
                    }}
                  >
                    {selectedMachine.power.map((pwr) => (
                      <option key={pwr} value={pwr}>{pwr}W</option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
